// Test IDs for panel components

export const PANEL_TEST_IDS = {
  CLOSE_BTN: 'panel-close-btn',
  getContentId: (suffix: string) => `panel-content-${suffix}`,
} as const;

